module.exports = __webpack_public_path__ + "img/picture_ksdyb.bd3fec4d.png";